// Patch global window interface to allow polyfill.
declare global {
  interface Window {
    Promise: PromiseConstructor;
  }
}

import 'whatwg-fetch';

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js'); // eslint-disable-line dot-notation
}

require('core-js/es6/symbol');
require('core-js/es6/object');
require('core-js/es6/map');
require('core-js/es6/set');
require('core-js/fn/array/find');
require('core-js/fn/array/from');
require('core-js/fn/array/includes');
require('core-js/fn/string/includes');

// ChildNode.remove() polyfill.
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function polyfillNodes(arr) {
  //eslint-disable-line wrap-iife
  arr.forEach(function polyfillNode(item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) {
          this.parentNode.removeChild(this);
        }
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]); //eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/lib/polyfills.ts